import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

// import {faLink} from '@fortawesome/free-solid-svg-icons'
// import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
// import {EDIT_MODE} from "../../../../../../wpconfig"

import * as Actions from "../../../../../../store/modules/journals";
import * as FActions from "../../../../../../store/modules/footer";
// import * as func from "../../../../../../utils/functions";

import JournalCategory from "./category";
import JournalCategory2 from "./category/index2";
import * as func from "../../../../../../utils/functions";

class JournalCategories extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isInint: false,
			category: {},
		}

		func.getData("category/journal/" + this.props.record.journal_id + '/', {}).then((response) => {
			this.setState({
				isInint: true,
				category: response.record
			})
		});

		this.showMessage = this.showMessage.bind(this);
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	render() {
		if (!this.state.isInint)
			return '';

		return (
			<>
				<h5 className="mt-4 mb-0">카테고리 정보</h5>
				<div className="row">
					<div className="col">
						<div className="card p-0">
							<JournalCategory2
								title="JCR 카테고리"
								type="jcr_category"
								category={this.state.category.jcr_category}
								record_id={this.props.record.journal_id}
								showMessage={this.showMessage}/>
						</div>
					</div>
					<div className="col">
						<div className="card p-0" style={{maxWidth: '100%'}}>
							<JournalCategory2
								title="Scopus 카테고리"
								type="scopus_category"
								category={this.state.category.scopus_category}
								record_id={this.props.record.journal_id}
								showMessage={this.showMessage}
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col">
						<div className="card p-0" style={{maxWidth: '100%'}}>
							<JournalCategory2
								title="KCI 카테고리"
								type="kci_category"
								category={this.state.category.kci_category}
								record_id={this.props.record.journal_id}
								showMessage={this.showMessage}
							/>
						</div>
					</div>
					<div className="col">
						<div className="card p-0">
							<JournalCategory2
								title="주제 카테고리"
								type="subject"
								category={this.state.category.subject}
								record_id={this.props.record.journal_id}
								showMessage={this.showMessage}/>
						</div>
					</div>
				</div>
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.journals.record ? state.journals.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(JournalCategories)
